import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

const fetchAdsStart = () => {
  return {
    type: actionTypes.FETCH_ADS_START,
  };
};

const fetchAdsSuccess = (clicks, total) => {
  return {
    clicks,
    total,
    type: actionTypes.FETCH_ADS_SUCCESS,
  };
};

const fetchAdsFailed = (error) => {
  return {
    error,
    type: actionTypes.FETCH_ADS_FAILED,
  };
};

// Receiving 0-based, convert to 1-based pagination for backend
export const onFetchAds = (page, limit, order, params) => {
  return async (dispatch) => {
    await dispatch(fetchAdsStart());

    let url = `${config.referrals}?limit=${limit}&page=${
      page + 1
    }&sort=${order}`;
    if (params) {
      url += `&${params}`;
    }

    try {
      const response = await axios.get(url);
      await dispatch(
        fetchAdsSuccess(response.data, response.headers["x-total-count"])
      );
    } catch (e) {
      await dispatch(fetchAdsFailed());
    }
  };
};

// FILTER
export const onFilterAds = () => {
  return {
    type: actionTypes.FILTER_ADS_SUCCESS,
  };
};

const filterAdsResetStart = () => {
  return {
    type: actionTypes.FILTER_ADS_RESET,
  };
};

export const onFilterAdsReset = () => {
  return async (dispatch) => {
    await dispatch(filterAdsResetStart());
    await dispatch(onFetchAds(0, 20, "-created_at"));
  };
};
